export default {
    url: '/add',
    template: '<courses-fields-add field="vm.field"/>',
    controller (ClassifierResource, CLASSIFIER_ENUM) {
        this.field = new ClassifierResource({
            type: CLASSIFIER_ENUM.KEYS.FIELD
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/fields/add/index.js